import React from "react";

// Classnames
import clsx from "clsx";

// components
import CartDrug from "components/Carts/CartDrug";

// Type
import { TItem } from "../type";

// Interface
interface IListDrugs {
  data?: TItem[];
}

export const ListDrugs: React.FC<IListDrugs> = (props) => {
  const { data = [] } = props;

  const countData = data?.length || 0;

  const cnWrapperList = clsx(
    "impurities-for-drug__list flex mb30",
    countData === 1 ? "impurities-for-drug__list--active" : "",
  );

  return data?.length
    ? <div className={cnWrapperList}>
      {data?.map(
        (item, i) => <CartDrug
          {...item}
          countData={countData}
          key={crypto.randomUUID()}
          uniqId={i === 0 ? 'drug-individual-id' : ''}
        />
      )}
    </div>
    : <></>;
};

export default ListDrugs;
